import AndrenaHelianthiformisPhoto from "../assets/images/bees/andrena_helianthiformis.jpg";
import AndrenaRuncinataePhoto from "../assets/images/bees/andrena_runcinatae_female.jpg";
import AndrenaPhoto from "../assets/images/bees/andrena.png";
import ColletesAndrewsiPhoto from "../assets/images/bees/colletes_andrewsi_male.jpg";
import DieunomiaFemalePhoto from "../assets/images/bees/dieunomia_female.jpg";
import MelissodesPhoto from "../assets/images/bees/melissodes.png";
import NomadaPhoto from "../assets/images/bees/nomada.png";
import TriepeolousPhoto from "../assets/images/bees/triepeolus.png";

interface BeeGalleryType {
  name: string;
  image: string;
}

export const BEE_GALLERY: BeeGalleryType[] = [
  {
    name: "Andrena chromotricha",
    image: AndrenaPhoto,
  },
  {
    name: "Melissodes wheeleri",
    image: MelissodesPhoto,
  },
  {
    name: "Nomada vincta",
    image: NomadaPhoto,
  },
  {
    name: "Triepeolus rhododontus",
    image: TriepeolousPhoto,
  },
  {
    name: "Colletes andrewsi",
    image: ColletesAndrewsiPhoto,
  },
  {
    name: "Dieunomia triangulifera",
    image: DieunomiaFemalePhoto,
  },
  {
    name: "Andrena helianthiformis",
    image: AndrenaHelianthiformisPhoto,
  },
  {
    name: "Andrena runcinatae",
    image: AndrenaRuncinataePhoto,
  },
];

export type { BeeGalleryType };
